import {useEffect, useState} from 'react';

export type OnlineStatusSubscriber = (isOnline: boolean) => void;

const subscribers = new Set<OnlineStatusSubscriber>();

export const on = (listener: OnlineStatusSubscriber) => {
	subscribers.add(listener);
	return () => off(listener);
};

export const off = (listener: OnlineStatusSubscriber) => {
	subscribers.delete(listener);
};

const publish = (isOnline: boolean) => {
	subscribers.forEach((listener) => listener(isOnline));
};

window.addEventListener('online', () => publish(true));
window.addEventListener('offline', () => publish(false));

export const useOnlineStatus = () => {
	const [isOnline, setIsOnline] = useState(navigator.onLine);

	useEffect(() => {
		on(setIsOnline);
		return () => {
			off(setIsOnline);
		};
	}, []);

	return isOnline;
};

export default useOnlineStatus;
